<!-- ── En-tête ─────────────────────────────────────────────────────── -->
 
<section class="cuspage-hero">
    <div class="cuspage-hero__bg"></div>
    <div class="container">
        <div class="cuspage-hero__content">
             <span class="cuspage-hero__tagline" style="display:none;">
                <i class="icofont-justice-hammer"></i>
                {{ 'galerie_titre' | translate }}
            </span>
            <h1 class="cuspage-hero__title">{{ 'galerie_titre' | translate }}</h1>
            <p class="cuspage-hero__sub"> </p>  
        </div>
    </div>
</section>
<!-- ── Section galerie ─────────────────────────────────────────────── -->
<section class="gallery-page">
    <div class="container">

        <!-- Filtres -->
        <div class="gallery-page__filters">
            <button class="gallery-filter-btn"
                    [class.active]="activeFilter === 'all'"
                    (click)="setFilter('all')">
                <i class="icofont-ui-image"></i> {{ 'galerie_filtre_tous' | translate }}
            </button>
            <button class="gallery-filter-btn"
                    [class.active]="activeFilter === 'image'"
                    (click)="setFilter('image')">
                <i class="icofont-image"></i> {{ 'galerie_filtre_images' | translate }}
            </button>
            <button class="gallery-filter-btn"
                    [class.active]="activeFilter === 'video'"
                    (click)="setFilter('video')">
                <i class="icofont-video-alt"></i> {{ 'galerie_filtre_videos' | translate }}
            </button>
        </div>

        <!-- Chargement -->
        <app-loading *ngIf="loading"></app-loading>

        <!-- Erreur -->
        <div *ngIf="error && !loading" class="gallery-page__error">
            <i class="icofont-warning-alt"></i>
            {{ error | translate }}
        </div>

        <!-- Grille -->
        <div *ngIf="!loading && !error" class="row gutter-y-30">

            <div class="col-lg-4 col-md-6"
                 *ngFor="let gallery of filtered; let i = index">
                <div class="gallery-card wow fadeInUp"
                     data-wow-duration="1000ms"
                     [attr.data-wow-delay]="(i % 3) * 100 + 'ms'">

                    <!-- Badge type -->
                    <span class="gallery-card__badge"
                          [class.gallery-card__badge--video]="gallery.type === 'video'">
                        <i [class]="gallery.type === 'video' ? 'icofont-video-alt' : 'icofont-image'"></i>
                        {{ (gallery.type === 'video' ? 'galerie_type_video' : 'galerie_type_image') | translate }}
                    </span>

                    <!-- Image -->
                    <div class="gallery-card__image">
                        <img [src]="getFeatured(gallery)" [alt]="gallery.name">
                        <div class="gallery-card__overlay">
                            <div class="gallery-card__overlay-inner">
                                <h4 class="gallery-card__name">{{ gallery.name }}</h4>
                                <p class="gallery-card__count" *ngIf="getCount(gallery) > 0">
                                    <i class="icofont-image"></i>
                                    {{ getCount(gallery) }} {{ (getCount(gallery) > 1 ? 'galerie_medias' : 'galerie_media') | translate }}
                                </p>
                                <a [routerLink]="['/galerie', gallery.id]"
                                   class="gallery-card__btn">
                                    {{ 'galerie_voir' | translate }}
                                    <i class="icofont-double-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Info bas de carte -->
                    <div class="gallery-card__footer">
                        <span class="gallery-card__title">{{ gallery.name }}</span>
                        <span class="gallery-card__views">
                            <i class="icofont-eye-alt"></i> {{ gallery.views }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Aucun résultat après filtre -->
            <div *ngIf="filtered.length === 0" class="col-12 gallery-page__empty">
                <i class="icofont-image"></i>
                <p>{{ 'galerie_aucune' | translate }}</p>
            </div>

        </div>

        <!-- Pagination -->
        <div *ngIf="totalPages > 1 && !loading" class="gallery-page__pagination">
            <ul class="post-pagination blog-page__pagination">
                <li>
                    <a (click)="loadPage(page - 1)"
                       [class.disabled-link]="page <= 1"
                       style="cursor:pointer">
                        <span class="icofont-double-left"></span>
                    </a>
                </li>
                <li *ngFor="let p of pages">
                    <a (click)="loadPage(p)"
                       [class.current]="page === p"
                       style="cursor:pointer">{{ p }}</a>
                </li>
                <li>
                    <a (click)="loadPage(page + 1)"
                       [class.disabled-link]="page >= totalPages"
                       style="cursor:pointer">
                        <span class="icofont-double-right"></span>
                    </a>
                </li>
            </ul>
        </div>

    </div>
</section>
